export * from './components';
export * from './adapters';
export * from './types';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';

import { ComponentId } from "@omegagrid/core";
import { AppComponent, Application, Container, parseComponentId } from '@reporting/rp-app-host';
import { ModuleCode } from '@reporting/rp-types/accounting';
import { ModuleDefinition } from '@reporting/rp-types/definition'
import { componentFactories } from './factories';

export class DefinitionApplication extends Application {

	modules: Map<ModuleCode, ModuleDefinition>;

	async getModules() {
		if (this.modules) return this.modules;
		const modules = await this.container.ms('definition').get<ModuleDefinition[]>('appModules');
		this.modules = new Map(modules.map(module => [module.module as ModuleCode, module]));
		return this.modules;
	}

	async init(container: Container) {
		super.init(container);
		container.services.register('definition');
		container.services.register('analytics');
		container.services.register('accounting');
		container.services.register('extensions');

		await this.getModules();
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		let parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		return factory(this, parsedId);
	}
}
